module.exports = __webpack_public_path__ + "img/jobs.a43323c4.svg";